// extracted by mini-css-extract-plugin
export var footer = "index-module--footer--qFkWd";
export var footerWrapper = "index-module--footerWrapper--xLJGO";
export var qrcode = "index-module--qrcode--RyCoN";